import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import api from '@/api/client';

/**
 * Handles the Emergent Google OAuth callback.
 * Reads #session_id from URL fragment, exchanges with backend for JWT,
 * stores token, then navigates to the appropriate page.
 */
export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    // Prevent double-execution under React StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/login');
      return;
    }

    const sessionId = decodeURIComponent(match[1]);
    // Clear the fragment from the URL immediately
    window.history.replaceState(null, '', window.location.pathname);

    api.post('/auth/google', { session_id: sessionId })
      .then(r => {
        localStorage.setItem('tlr_token', r.data.access_token);
        const user = r.data.user;
        setUser(user);
        // Navigate based on role/status (mirrors Login.js logic)
        if (user.role === 'admin') navigate('/admin', { replace: true });
        else if (user.role === 'member') navigate('/dashboard', { replace: true });
        else if (!user.profile_completed) navigate('/profile/complete', { replace: true });
        else if (user.membership_status === 'none') navigate('/membership/apply', { replace: true });
        else navigate('/membership/status', { replace: true });
      })
      .catch(() => {
        navigate('/login?error=google_auth_failed', { replace: true });
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: '#fff' }}>
      <div style={{ width: '28px', height: '28px', border: '2px solid #E5E5E5', borderTopColor: '#000', borderRadius: '50%', animation: 'spin 0.7s linear infinite' }} />
      <p style={{ marginTop: '1.5rem', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.15em', color: '#999' }}>
        Signing you in…
      </p>
    </div>
  );
}
